/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import Carousel from 'mfcl/Carousel';
import * as React from 'react';
import _getViewPort from '../../Utilities/get-view-port';
import { IMfrmProductRecommendationsViewProps } from './mfrm-product-recommendations';
import { Image } from '@msdyn365-commerce/core';

export default (props: IMfrmProductRecommendationsViewProps) => {
    const styles = 'mfrm-recommendation-module__';
    const [loaded, setIsLoaded] = React.useState(false);
    const hideLoader = () => {
        setIsLoaded(true);
    };
    const { carouselItems } = props;
    const minDesktop = carouselItems && carouselItems.length === 4 ? 'min-desktop' : '';
    const mobile = _getViewPort(props.context) === 'sm';

    React.useEffect(hideLoader, []);
    return (
        carouselItems &&
        carouselItems.length > 3 && (
            <>
                {props.config.avatarImage && <div className={`${styles}avatarheadingcontainer`}>
                    <div className={`${styles}avatarcontentcontainer`}>
                        {props.config.avatarImage && (
                            <div className={`${styles}avatarimagecontainer`}>
                                <Image
                                    {...props.config.avatarImage}
                                    alt={props.config.avatarImage.altText}
                                    className={`${styles}avatarimage`}
                                    src={props.config.avatarImage.src || ''}
                                    gridSettings={props.context.request.gridSettings!}
                                />
                            </div>
                        )}
                        <div className={`${styles}avatartextcontainer`}>
                            {props.config.heading && <div className={`${styles}avatarheading`}>{props.config.heading.text}</div>}
                            {props.config.subHeading && (
                                <div className={`${styles}avatarsubheading`}> {props.config.subHeading.text}</div>
                            )}
                            {props.config.link && (
                                <a
                                    className={`${styles}avatarsubheadinglink`}
                                    href={props.config.link?.linkUrl.destinationUrl}
                                    target={props.config.link?.openInNewTab ? '_blank' : '_self'}
                                >
                                    {props.config.link?.linkText}
                                </a>
                            )}
                        </div>
                    </div>
                </div>}
                <div className='mfrm-content-reel'>
                    <div className={`mfcl-carousel__container ${loaded ? '' : 'carousel-loading'}`}>
                        {mobile ? (
                            <div className='mfcl-carousel__mobile'>
                                <Carousel
                                    itemsToShow={2}
                                    ariaLabel='one'
                                    hideIndicators
                                    hideControls
                                    disableControls
                                    disableAutoShift
                                    controlStyle='legacy'
                                    controlClass={`mfcl-carousel__button ${minDesktop}`}
                                    disableEndButtons={mobile}
                                    variableWidth={mobile}
                                >
                                    {carouselItems}
                                </Carousel>
                            </div>
                        ) : (
                            <Carousel
                                itemsToShow={4}
                                ariaLabel='one'
                                hideIndicators
                                hideControls
                                controlStyle='legacy'
                                controlClass={`mfcl-carousel__button ${minDesktop}`}
                                disableEndButtons={true}
                                variableWidth={mobile}
                                responsive={[
                                    {
                                        breakpoint: 1150,
                                        itemsToShow: 3
                                    },
                                    {
                                        breakpoint: 564,
                                        itemsToShow: 1,
                                        layoutGap: 14
                                    }
                                ]}
                            >
                                {carouselItems}
                            </Carousel>
                        )}
                    </div>
                </div>
            </>
        )
    );
};
